import { useMemo } from 'react';

import useGet from 'lib/hooks/useGet';
import { ANNUALIZED_MFR_GMV_MANUFACTURERS } from 'lib/networking/endpoints';

/**
 * useMfrManufacturers — manufacturers ordered by GMV for the MSV home grid.
 *
 * Hits GET /annualized-mfr-gmv/manufacturers (params: limit, offset, query,
 * l1_category_id, l2_category_id, distributor_id). The backend applies the
 * deepest category filter (L2 over L1) and only returns manufacturers with a
 * matching GMV row when a category/distributor filter is active.
 *
 * Returns { data: { manufacturers: [], count }, loading, error, refetch }.
 */
function useMfrManufacturers({
  offset = 0,
  limit = 50,
  searchQuery,
  l1CategoryId,
  l2CategoryId,
  distributorId,
  thirdPartyTag,
  skip = false,
} = {}) {
  const trimmed = (searchQuery || '').trim();
  const params = useMemo(() => {
    const p = { offset, limit };
    if (trimmed) p.query = trimmed;
    if (l1CategoryId) p.l1_category_id = l1CategoryId;
    if (l2CategoryId) p.l2_category_id = l2CategoryId;
    if (distributorId) p.distributor_id = distributorId;
    if (thirdPartyTag) p.third_party_tag = thirdPartyTag;
    return p;
  }, [offset, limit, trimmed, l1CategoryId, l2CategoryId, distributorId, thirdPartyTag]);

  return useGet(ANNUALIZED_MFR_GMV_MANUFACTURERS, params, skip);
}

export default useMfrManufacturers;
